import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  width: 100%;
  height: fit-content;

  ${({ size }) => css`
    ${Label} {
      ${LabelFont(size)};
    }
  `}

  * {
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const LabelFont = (size) => {
  switch (size) {
    case "xs":
    case "sm":
    case "md":
      return css`
        font-size: 16px;
        line-height: 19.52px;
      `;
    case "lg":
    default:
  }
};

export const Label = styled.label`
  position: relative;
  font-weight: 400;
  letter-spacing: 0.02em;
  text-align: left;

  width: fit-content;

  color: ${({ theme }) => theme.colors.primary.cetaceanBlue};

  ${({ required }) => {
    if (required) {
      return css`
        &::after {
          position: absolute;
          top: 0;
          right: -8px;
          content: "";
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: ${({ theme }) =>
            theme.colors.feedbackState.critical.default};
        }
      `;
    }
  }}
`;

export const Select = styled.select`
  width: 100%;
  height: 32px;
`;

export const CustomStyles = (theme, size, alertType, disabled) => ({
  control: (base, state) => {
    const style = {
      ...base,
      borderRadius: "6px",
      fontWeight: "400",
      overflow: "hidden",
      height: "fit-content",
    };

    if (state.isFocused || state.isSelected) {
      style.border = `border: 1.5px solid ${theme.colors.primary.vividCerulean}`;
    }

    switch (alertType) {
      case "error":
        style.border = `1px solid ${theme.colors.feedbackState.critical.default}`;
        break;
      case "success":
        style.border = `1px solid ${theme.colors.feedbackState.success.default}`;
        break;
      case "warning":
        style.border = `1px solid ${theme.colors.feedbackState.warning.default}`;
        break;
      default:
        style.border = `1px solid ${theme.colors.neutral.gray4}`;
    }

    if (disabled) {
      style.border = `1px solid ${theme.colors.neutral.gray4}`;
      style.backgroundColor = theme.colors.neutral.gray2;
    }

    switch (size) {
      case "xs":
        style.fontSize = "12px";
        style.lineHeight = "130%";
        style.height = "32px";
        break;
      case "sm":
        style.fontSize = "14px";
        style.lineHeight = "146%";
        style.height = "44px";
        break;
      default:
      case "md":
        style.fontSize = "16px";
        style.lineHeight = "150%";
        style.height = "48px";
        break;
      case "lg":
        style.fontSize = "20px";
        style.lineHeight = "120%";
        style.height = "56px";
        break;
    }

    return style;
  },

  valueContainer: (base) => {
    const style = {
      ...base,
      padding: "0",
      margin: "0",
      height: "fit-content",
      flex: 1,
      flexWrap: "nowrap",
      width: "max-content",
      overflowY: "hidden",
      overflowX: "auto",
      gap: "4px",
    };

    switch (size) {
      case "xs":
        style.padding = "8px";
        break;
      case "sm":
        style.padding = "12px";
        break;
      default:
      case "md":
        style.padding = "12px";
        break;
      case "lg":
        style.padding = "16px";
        break;
    }

    return style;
  },

  input: (base) => {
    const style = {
      ...base,
      padding: "0",
      margin: "0",
    };

    return style;
  },

  indicatorSeparator: (base) => {
    const style = {
      ...base,
      display: "none",
    };

    return style;
  },

  dropdownIndicator: (base) => {
    const style = {
      ...base,
      color: theme.colors.primary.cetaceanBlue,
      padding: "0",
    };

    switch (size) {
      case "xs":
        style.paddingRight = "8px";
        break;
      case "sm":
        style.paddingRight = "12px";
        break;
      default:
      case "md":
        style.paddingRight = "12px";
        break;
      case "lg":
        style.paddingRight = "16px";
        break;
    }

    if (disabled) {
      style.color = theme.colors.neutral.gray4;
    }

    switch (size) {
      case "xs":
        style.svg = {
          width: "16px",
          height: "16px",
        };
        break;
      case "sm":
        style.svg = {
          width: "20px",
          height: "20px",
        };
        break;
      default:
      case "md":
        style.svg = {
          width: "24px",
          height: "24px",
        };
        break;
      case "lg":
        style.svg = {
          width: "24px",
          height: "24px",
        };
        break;
    }

    return style;
  },

  placeholder: (base) => {
    const style = {
      ...base,
      color: theme.colors.neutral.gray4,
      fontWeight: "300",
    };

    return style;
  },

  multiValue: (base) => {
    const style = {
      ...base,
      width: "max-content",
      minWidth: "min-content",
      height: "min-content",
      margin: "0",
    };

    switch (size) {
      case "xs":
        style.height = "16px";
        break;
      case "sm":
        style.height = "20px";
        break;
      default:
      case "md":
        style.height = "24px";
        break;
      case "lg":
        style.height = "24px";
        break;
    }

    return style;
  },

  multiValueLabel: (base) => {
    const style = {
      ...base,
      textOverflow: "none",
    };

    switch (size) {
      case "xs":
        style.fontSize = "12px";
        style.lineHeight = "100%";
        break;
      case "sm":
        style.fontSize = "14px";
        style.lineHeight = "100%";
        break;
      default:
      case "md":
        style.fontSize = "16px";
        style.lineHeight = "130%";
        break;
      case "lg":
        style.fontSize = "20px";
        style.lineHeight = "100%";
        break;
    }

    return style;
  },
});
